import type { Channel } from '../types/Channel';
import type { PlaylistItem } from '../types/PlaylistItem';

export interface MockPlayerData {
  channel: Channel;
  currentSong: PlaylistItem;
  playbackMode: 'audio' | 'av';
  playlist: PlaylistItem[];
}

const mockChannels: Record<string, MockPlayerData> = {
  demo: {
    channel: {
      slug: 'demo',
      name: 'RFW Vibes',
      logo: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20radio%20station%20logo%20design%20with%20abstract%20sound%20wave%20in%20warm%20amber%20tones%20on%20dark%20background%2C%20clean%20geometric%20shapes%2C%20circular%20emblem%20style%2C%20professional%20broadcast%20identity%2C%20no%20text%2C%20high%20contrast%2C%20vector%20art%20style&width=400&height=400&seq=player-logo-demo&orientation=squarish',
      background: 'https://readdy.ai/api/search-image?query=Dark%20atmospheric%20abstract%20sound%20visualization%20with%20flowing%20waveforms%20in%20warm%20amber%20and%20emerald%20accents%20on%20deep%20charcoal%20background%2C%20smooth%20gradients%2C%20minimalist%20ambient%20texture%2C%20modern%20audio%20visualizer%20aesthetic%2C%20no%20text%2C%20subtle%20glow%20effects&width=1600&height=900&seq=player-bg-demo&orientation=landscape',
      playbackMode: 'audio',
      isLive: true,
      frequency: '94.07 RFW',
      listeners: 2843,
    },
    currentSong: {
      id: 'audio-1',
      type: 'audio',
      title: 'Midnight Frequencies',
      artist: 'Luna Wave',
      album: 'Neon Signals',
      duration: 234,
      cover: 'https://readdy.ai/api/search-image?query=Music%20album%20cover%20art%20with%20abstract%20neon%20waveforms%20and%20warm%20gradients%20on%20dark%20background%2C%20minimalist%20design%2C%20geometric%20shapes%2C%20modern%20electronic%20music%20aesthetic%2C%20soft%20glow%2C%20clean%20composition%2C%20no%20text&width=600&height=600&seq=player-cover-demo&orientation=squarish',
      media_url: 'https://example.com/audio/midnight-frequencies.mp3',
      thumbnail_url: 'https://readdy.ai/api/search-image?query=Music%20album%20cover%20art%20with%20abstract%20neon%20waveforms%20and%20warm%20gradients%20on%20dark%20background%2C%20minimalist%20design%2C%20geometric%20shapes%2C%20modern%20electronic%20music%20aesthetic%2C%20soft%20glow%2C%20clean%20composition%2C%20no%20text&width=600&height=600&seq=player-cover-demo&orientation=squarish',
      duration_seconds: 234,
      sort_order: 1,
      is_active: true,
    },
    playbackMode: 'audio',
    playlist: [
      {
        id: 'audio-1',
        type: 'audio',
        title: 'Midnight Frequencies',
        artist: 'Luna Wave',
        album: 'Neon Signals',
        duration: 234,
        cover: 'https://readdy.ai/api/search-image?query=Music%20album%20cover%20art%20with%20abstract%20neon%20waveforms%20and%20warm%20gradients%20on%20dark%20background%2C%20minimalist%20design%2C%20geometric%20shapes%2C%20modern%20electronic%20music%20aesthetic%2C%20soft%20glow%2C%20clean%20composition%2C%20no%20text&width=600&height=600&seq=player-cover-demo&orientation=squarish',
        media_url: 'https://example.com/audio/midnight-frequencies.mp3',
        thumbnail_url: 'https://readdy.ai/api/search-image?query=Music%20album%20cover%20art%20with%20abstract%20neon%20waveforms%20and%20warm%20gradients%20on%20dark%20background%2C%20minimalist%20design%2C%20geometric%20shapes%2C%20modern%20electronic%20music%20aesthetic%2C%20soft%20glow%2C%20clean%20composition%2C%20no%20text&width=600&height=600&seq=player-cover-demo&orientation=squarish',
        duration_seconds: 234,
        sort_order: 1,
        is_active: true,
      },
      {
        id: 'audio-2',
        type: 'audio',
        title: 'Urban Pulse',
        artist: 'DJ Cascade',
        album: 'City Lights EP',
        duration: 198,
        cover: 'https://readdy.ai/api/search-image?query=Dark%20abstract%20album%20cover%20with%20pulsing%20circles%20and%20warm%20amber%20gradients%20on%20black%20background%2C%20minimalist%20geometric%20design%2C%20modern%20electronic%20music%20art%2C%20clean%20composition%2C%20no%20text&width=600&height=600&seq=player-cover-2&orientation=squarish',
        media_url: 'https://example.com/audio/urban-pulse.mp3',
        thumbnail_url: 'https://readdy.ai/api/search-image?query=Dark%20abstract%20album%20cover%20with%20pulsing%20circles%20and%20warm%20amber%20gradients%20on%20black%20background%2C%20minimalist%20geometric%20design%2C%20modern%20electronic%20music%20art%2C%20clean%20composition%2C%20no%20text&width=600&height=600&seq=player-cover-2&orientation=squarish',
        duration_seconds: 198,
        sort_order: 2,
        is_active: true,
      },
      {
        id: 'audio-3',
        type: 'audio',
        title: 'Solar Drift',
        artist: 'Atlas Bloom',
        album: 'Horizon Lines',
        duration: 267,
        cover: 'https://readdy.ai/api/search-image?query=Minimalist%20album%20cover%20with%20horizontal%20gradient%20lines%20in%20warm%20earth%20tones%20on%20dark%20background%2C%20abstract%20landscape%20vibe%2C%20clean%20modern%20design%2C%20no%20text&width=600&height=600&seq=player-cover-3&orientation=squarish',
        media_url: 'https://example.com/audio/solar-drift.mp3',
        thumbnail_url: 'https://readdy.ai/api/search-image?query=Minimalist%20album%20cover%20with%20horizontal%20gradient%20lines%20in%20warm%20earth%20tones%20on%20dark%20background%2C%20abstract%20landscape%20vibe%2C%20clean%20modern%20design%2C%20no%20text&width=600&height=600&seq=player-cover-3&orientation=squarish',
        duration_seconds: 267,
        sort_order: 3,
        is_active: true,
      },
      {
        id: 'img-1',
        type: 'image',
        title: 'Summer Fest 2026 — Official Poster',
        media_url: 'https://readdy.ai/api/search-image?query=Vibrant%20summer%20music%20festival%20poster%20design%20with%20warm%20sunset%20gradients%20and%20silhouette%20crowd%2C%20bold%20graphic%20shapes%2C%20modern%20event%20promotion%20aesthetic%2C%20dark%20background%20with%20neon%20accents%2C%20clean%20typography%20layout%2C%20no%20text%20readable&width=1200&height=800&seq=player-img-1&orientation=landscape',
        thumbnail_url: 'https://readdy.ai/api/search-image?query=Vibrant%20summer%20music%20festival%20poster%20design%20with%20warm%20sunset%20gradients%20and%20silhouette%20crowd%2C%20bold%20graphic%20shapes%2C%20modern%20event%20promotion%20aesthetic%2C%20dark%20background%20with%20neon%20accents&width=600&height=400&seq=player-img-1-thumb&orientation=landscape',
        display_duration_seconds: 15,
        sort_order: 4,
        is_active: true,
      },
      {
        id: 'img-2',
        type: 'image',
        title: 'AudioTech Pro — Sponsor Banner',
        media_url: 'https://readdy.ai/api/search-image?query=Professional%20audio%20equipment%20brand%20sponsorship%20banner%20with%20sleek%20headphones%20and%20studio%20gear%20on%20dark%20gradient%20background%2C%20warm%20metallic%20accents%2C%20modern%20product%20photography%20style%2C%20clean%20composition&width=1200&height=800&seq=player-img-2&orientation=landscape',
        thumbnail_url: 'https://readdy.ai/api/search-image?query=Professional%20audio%20equipment%20brand%20sponsorship%20banner%20with%20sleek%20headphones%20and%20studio%20gear%20on%20dark%20gradient%20background%2C%20warm%20metallic%20accents&width=600&height=400&seq=player-img-2-thumb&orientation=landscape',
        display_duration_seconds: 10,
        sort_order: 5,
        is_active: true,
      },
      {
        id: 'vid-1',
        type: 'video',
        title: 'Behind the Mic — Studio Tour',
        media_url: 'https://example.com/video/studio-tour.mp4',
        thumbnail_url: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20radio%20studio%20with%20warm%20ambient%20lighting%20and%20professional%20broadcast%20equipment%2C%20microphone%20in%20foreground%2C%20soundproof%20panels%2C%20modern%20studio%20aesthetic%2C%20cinematic%20composition%2C%20dark%20moody%20tones&width=1200&height=675&seq=player-vid-1&orientation=landscape',
        duration_seconds: 180,
        sort_order: 6,
        is_active: true,
      },
      {
        id: 'audio-hidden',
        type: 'audio',
        title: 'Hidden Bonus Track',
        artist: 'Ghost Signal',
        media_url: 'https://example.com/audio/hidden-track.mp3',
        sort_order: 7,
        is_active: false,
      },
    ],
  },
};

export function getMockPlayer(slug: string): MockPlayerData | null {
  return mockChannels[slug] ?? null;
}